import React, { useState, useEffect } from 'react';

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(true);

  // Load theme preference on component mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = savedTheme === 'dark' || (!savedTheme && true); // default to dark
    
    setIsDark(prefersDark);
    
    // Apply theme to document
    if (prefersDark) {
      document.documentElement.classList.remove('light-theme');
    } else {
      document.documentElement.classList.add('light-theme');
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = !isDark;
    setIsDark(newTheme);
    
    // Update DOM
    if (newTheme) {
      document.documentElement.classList.remove('light-theme');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.add('light-theme');
      localStorage.setItem('theme', 'light');
    }

    // Optional: Add a subtle haptic feedback effect
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
  };

  return (
    <button 
      onClick={toggleTheme} 
      className="theme-toggle"
      title={`Switch to ${isDark ? 'light' : 'dark'} theme`}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} theme`}
    >
      <span className="theme-icon">
        {isDark ? '☀️' : '🌙'}
      </span>
      {/* <span style={{ fontSize: '0.85rem', fontWeight: '500' }}>
        {isDark ? 'Light' : 'Dark'}
      </span> */}
    </button>
  );
};

export default ThemeToggle;